import { cn } from '@/lib/utils';
import { Spinner } from './spinner';

function Skeleton({
  className,
  loading,
  showSpinner,
  children,
  ...props
}: React.ComponentProps<'div'> & {
  loading?: boolean;
  showSpinner?: boolean;
  children?: React.ReactNode;
}) {
  if (!children) {
    return (
      <div
        data-slot="skeleton"
        className={cn(
          'tw:bg-secondary tw:animate-pulse tw:rounded-md',
          className,
        )}
        {...props}
      />
    );
  }

  if (!loading) return children;

  return (
    <div className="tw:relative tw:inline-block">
      <div
        data-slot="skeleton"
        className={cn(
          'tw:absolute tw:inset-0 tw:bg-secondary tw:animate-pulse tw:rounded-md',
          className,
        )}
        {...props}
      />
      {showSpinner && (
        <div className="tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center">
          <Spinner />
        </div>
      )}
      <div className="tw:invisible">{children}</div>
    </div>
  );
}

export { Skeleton };
